import { render, staticRenderFns } from "./VideoDouob.vue?vue&type=template&id=1446ca82&scoped=true&"
import script from "./VideoDouob.vue?vue&type=script&lang=js&"
export * from "./VideoDouob.vue?vue&type=script&lang=js&"
import style0 from "./VideoDouob.vue?vue&type=style&index=0&id=1446ca82&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1446ca82",
  null
  
)

export default component.exports